"use client";

import Image, { type StaticImageData } from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { memo } from "react";

export type TranslationDeliverablesCardLinkProps = {
  imageUrl?: string | StaticImageData;
  imageAlt: string;
  href?: string;
  ref?: React.Ref<HTMLDivElement>;
} & React.ComponentPropsWithoutRef<"div">;

const TranslationDeliverablesCardLink = ({
  children,
  href = "#",
  imageUrl,
  imageAlt,
  className,
  ref,
  ...rest
}: TranslationDeliverablesCardLinkProps) => {
  return (
    <div className={cn("flex", className)} ref={ref} {...rest}>
      <Link
        href={href}
        className="flex-auto min-w-0 flex flex-col p-4 pb-[37] md:p-5 bg-background-secondary lg:bg-white rounded-[14.26] flex text-semantic-text-primary transition-[box-shadow,border-color,background-color] border hover:border-blue-500 hover:shadow-[0px_8px_16px_0_rgba(0,0,0,0.08)]"
      >
        <div className="relative w-full flex">
          {!!imageUrl && (
            <Image
              src={imageUrl}
              alt={imageAlt}
              quality={100}
              width={171}
              height={91}
              className="object-contain w-full h-auto flex-auto min-w-0"
            />
          )}
        </div>
        <div className="flex-auto text-center text-lg leading-[130%] lg:font-medium pt-2.5 lg:pt-3">
          {children}
        </div>
      </Link>
    </div>
  );
};

export default memo(TranslationDeliverablesCardLink);
